import { render, staticRenderFns } from "./TimeDuration.vue?vue&type=template&id=380cdac6&scoped=true"
import script from "./TimeDuration.vue?vue&type=script&lang=js"
export * from "./TimeDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380cdac6",
  null
  
)

export default component.exports